import axios from "axios";
import router from "@/router";
import { REGISTRATION_MODES } from "@/config/variables.js";

const getDefaultState = () => {
  return {
    atuParams: null,
  };
};

export default {
  state: getDefaultState(),
  getters: {
    getAtuParams: (state) => state.atuParams,
    isAllRegistrationModes: (state) =>
      state?.atuParams?.atu_registration_mode ===
      REGISTRATION_MODES.PHYSICIANS_AND_PHARMACISTS,
    isAllowOrgCreation: (state) => state?.atuParams?.atu_sites_only === false,
    isMedSpecsEnabled: (state) => state?.atuParams?.med_specs_enabled,
  },
  mutations: {
    ATU_PARAMS(state, value) {
      state.atuParams = value;
    },
  },
  actions: {
    async GET_ATU_PARAMS(ctx) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      try {
        const resp = await axios.get(`/${client_name}/${context_key}/params`);

        const lang = resp.data.atu_locale;

        ctx.commit("MUTATE_APP_LANGUAGE", lang);
        ctx.commit("ATU_PARAMS", resp.data);
      } catch (e) {
        console.log(e);
        if (e?.response?.status === 400) {
          router.push({
            name: "PageError",
            params: {
              message: "Not Found Cleanweb",
            },
          });
        } else {
          router.push({
            name: "PageError",
          });
        }
        throw e;
      }
    },
  },
};
